import { REFUND } from "store/actions/type";
export default function refund(state = {}, action) {
    switch (action.type) {
        case REFUND:
            return action.payload;
        default:
            return state
    }
}